import Marquee from "react-fast-marquee";
import { Sun } from "lucide-react";
import { FadeUp } from "./Reveal";
import { LOCATION_IMAGE } from "@/data/apartments";
import { useLang } from "@/i18n";

const PLACES = ["Bordighera", "Riviera dei Fiori"];

export const LocationSection = () => {
  const { t } = useLang();
  return (
    <section id="contesto" data-testid="location-section">
      <div className="overflow-hidden border-y border-line bg-bone py-7">
        <Marquee speed={28} gradient={false} data-testid="location-marquee">
          {PLACES.map((p) => (
            <span key={p} className="mx-10 flex items-center gap-10 font-serif text-4xl font-light text-olive sm:text-5xl">
              {p}
              <Sun className="h-5 w-5 text-sand" strokeWidth={1} />
            </span>
          ))}
        </Marquee>
      </div>

      <div className="mx-auto max-w-[1440px] px-6 py-28 sm:px-10 sm:py-40">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-2 lg:gap-24">
          <div>
            <FadeUp>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-terracotta">{t.location.label}</p>
            </FadeUp>
            <FadeUp delay={0.1}>
              <h2 className="mt-6 font-serif text-4xl font-light leading-tight tracking-tight text-ink sm:text-5xl">
                {t.location.h2a}
                <em className="italic text-terracotta">{t.location.h2em}</em>
              </h2>
            </FadeUp>
            <FadeUp delay={0.18}>
              <p className="mt-8 max-w-lg text-base leading-relaxed text-[#4A4F4C] sm:text-lg">{t.location.p}</p>
            </FadeUp>
            <FadeUp delay={0.26} className="mt-12">
              <div className="group relative aspect-[4/3] overflow-hidden border border-line">
                <img
                  src={LOCATION_IMAGE}
                  alt={t.location.imgAlt}
                  loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-105"
                />
                <div className="pointer-events-none absolute inset-0 ring-1 ring-inset ring-ink/10" />
              </div>
            </FadeUp>
          </div>

          <div className="flex flex-col justify-center">
            <FadeUp delay={0.15}>
              <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-[#8A8D8B]">{t.location.distLabel}</p>
            </FadeUp>
            <div className="mt-8">
              {t.location.distances.map(([place, km], i) => (
                <FadeUp key={place} delay={0.05 * i} y={20} data-testid={`distance-row-${i}`}>
                  <div className="flex items-baseline justify-between border-t border-line py-5 last:border-b">
                    <span className="text-sm text-[#4A4F4C] sm:text-base">{place}</span>
                    <span className="font-serif text-2xl font-light text-terracotta">{km}</span>
                  </div>
                </FadeUp>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
